import React, { useState } from 'react';
import { LoginForm } from '../components/auth/LoginForm';
import { RegisterForm } from '../components/auth/RegisterForm';
import { PasswordResetForm } from '../components/auth/PasswordResetForm';
import { useLanguage } from '../contexts/LanguageContext';

type AuthView = 'login' | 'register' | 'password-reset';

export const AuthScreen: React.FC = () => {
  const { t } = useLanguage();
  const [currentView, setCurrentView] = useState<AuthView>('login');
  const [registrationMessage, setRegistrationMessage] = useState('');

  const handleRegistrationSuccess = () => {
    setRegistrationMessage(t('auth.authscreen.registration_success'));
    setCurrentView('login');
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'login':
        return (
          <LoginForm
            onSwitchToRegister={() => setCurrentView('register')}
            onSwitchToPasswordReset={() => setCurrentView('password-reset')}
          />
        );
      case 'register':
        return (
          <RegisterForm
            onSwitchToLogin={() => setCurrentView('login')}
            onRegistrationSuccess={handleRegistrationSuccess}
          />
        );
      case 'password-reset':
        return (
          <PasswordResetForm
            onSwitchToLogin={() => setCurrentView('login')}
          />
        );
      default:
        return (
          <LoginForm
            onSwitchToRegister={() => setCurrentView('register')}
            onSwitchToPasswordReset={() => setCurrentView('password-reset')}
          />
        );
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Show registration success message */}
      {registrationMessage && currentView === 'login' && (
        <div className="bg-green-50 border-b border-green-200 p-4">
          <div className="text-center">
            <div className="text-green-800 text-sm font-medium">
              ✅ {registrationMessage}
            </div>
          </div>
        </div>
      )}
      
      {renderCurrentView()}
    </div>
  );
};